<template>
  <div class="booxBanner-page">
    <div class="boox-main">
      <div class="header-boox-wrap">
        <button v-if="currentId" class="global-button-style" @click="del">
          {{ $t("commonMsg.del") }}
        </button>
        <button class="global-button-style" @click="save">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
      <div class="body-boox-wrap" v-bar>
        <div class="body-wrap">
          <el-form
            label-width="100px"
            @submit.native.prevent
            :model="formData"
            ref="ruleForm"
            label-position="top"
            :rules="rules"
          >
            <el-form-item label="标题" prop="title">
              <el-input v-model="formData.name"></el-input>
            </el-form-item>
            <el-form-item label="轮播图" class="pic">
              <div
                class="pic-item"
                v-for="(item, index) in formData.pictures"
                :key="index"
              >
                <div class="booxBanner-edit-cover" @click.stop="imgIdx = index">
                  <img v-if="item.key" :src="item.key" />
                  <i v-else class="booxBanner-edit-cover-icon el-icon-plus"></i>
                  <div class="booxBanner-edit-upload">
                    <el-upload
                      class="booxBanner-edit-upload-btn"
                      action
                      :accept="'image/*'"
                      :auto-upload="false"
                      :show-file-list="false"
                      :on-change="handleAvatarChange"
                    >
                      <div v-if="item.key" class="booxBanner-upload-icon">
                        替换
                      </div>
                    </el-upload>
                  </div>
                </div>
                <p v-if="index !== 0" class="booxBanner-item-del">
                  <i class="el-icon-delete" @click.stop="delItem(index)"></i>
                </p>
              </div>
              <button
                @click="addImgItem"
                class="global-button-style el-icon-plus"
                title="添加广告"
              ></button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { uploadOss } from "@/utils/aliyun";
export default {
  data() {
    return {
      formData: {
        name: "",
        lang: "en",
        pictures: [{ key: "", bucket: "onyx-static" }]
      },
      imgIdx: 0,
      currentId: null,
      rules: {
        // pic_address: [
        //   { required: true, message: "请选择广告封面", trigger: "change" }
        // ]
      }
    };
  },
  methods: {
    addImgItem() {
      this.formData.pictures.push({ key: "", bucket: "onyx-static" });
    },
    async handleAvatarChange(file, filtList) {
      let cover = await uploadOss(file, "onyx-static");
      this.formData.pictures[this.imgIdx].key = cover;
    },

    delItem(index) {
      this.formData.pictures.splice(1, index);
    },
    getAppAd() {
      this.$http.getAppAd({ lang: "en" }).then(res => {
        if (res.data) {
          this.currentId = res.data._id;
          this.formData.name = res.data.name;
          this.formData.pictures = res.data.pictures;
        }
      });
    },

    save() {
      for (let cover of this.formData.pictures) {
        if (!cover.key) {
          this.elMsg("轮播不能为空", "error");
          return;
        }
      }
      if (!this.currentId) {
        this.create();
      } else {
        this.edit();
      }
    },

    edit() {
      this.$http.updateAppAd(this.currentId, this.formData).then(res => {
        this.elMsg("保存成功", "success");
        this.getAppAd();
      });
    },

    create() {
      this.$http.appAd(this.formData).then(res => {
        this.elMsg("保存成功", "success");
        this.getAppAd();
      });
    },

    del() {
      this.$http.delAppAd(this.currentId).then(res => {
        this.elMsg("清除成功", "success");
        this.imgIdx = 0;
        this.currentId = null;
        this.formData = {
          name: "",
          pictures: [{ key: "", bucket: "onyx-static" }]
        };
      });
    }
  },
  mounted() {
    this.getAppAd();
  }
};
</script>

<style lang="scss">
.booxBanner-page {
  flex: 1;
  /* height: 100%; */
  display: flex;
  overflow: hidden;
  .boox-main {
    flex: 1;
    display: flex;
    margin: 20px;
    flex-direction: column;
    overflow: hidden;
    background: #fff;
    .header-boox-wrap {
      padding: 10px 20px;
      /* border-bottom: 1px solid #ccc; */
      text-align: right;
    }
    .body-boox-wrap {
      flex: 1;
      display: flex;
      overflow: hidden;
      .body-wrap {
        /* height: 100%; */
        flex: 1;
        .el-form {
          height: 100%;
          width: 80%;
          margin: 10px auto;
          .global-button-style {
            width: 100%;
            margin: 0;
          }
        }
        .pic {
          .pic-item {
            /* position: relative; */
            display: flex;
            overflow: hidden;
          }
          .booxBanner-item-del {
            display: flex;
            align-items: flex-end;
            > i {
              margin: 10px;
              font-size: 20px;
              color: #bb745c;
              cursor: pointer;
            }
          }
          .global-button-style {
            width: 80px;
            height: 30px;
          }
          .booxBanner-edit-cover {
            position: relative;
            width: 200px;
            height: 300px;
            overflow: hidden;
            margin: 10px 0;
            border: 2px dashed #ccc;
            border-radius: 10px;
            &:hover {
              border-color: #bb745c;
            }
            > img {
              width: 100%;
              height: 100%;
            }
            > .booxBanner-edit-cover-icon {
              font-weight: bold;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              color: #bb745c;
            }
            > .booxBanner-edit-upload {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              transition: all 0.2s;
              &:hover {
                transition: all 0.2s;
                background: rgba($color: #000000, $alpha: 0.4);
                .booxBanner-edit-upload-btn {
                  display: block;
                }
              }
              .booxBanner-edit-upload-btn {
                width: 100%;
                height: 100%;
                display: none;
                cursor: pointer;
                color: #fff;
                font-weight: bold;
                position: absolute;
                text-align: center;
                line-height: 300px;
                > .el-upload--text {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }
          .add-img {
            width: 70px;
            height: 40px;
            font-size: 22px;
            line-height: 43px;
            color: #fff;
            cursor: pointer;
            background-color: #bb745c;
          }
        }
      }
    }
  }
}
</style>
